<template>
    <div>
        <div class="form-group">
            <label>Email Address</label>
            <input type="text" class="form-control" v-model="data.emails">
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: [
        'data'
    ],
    data() {
        return {
        };
    }
}
</script>
